import React from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { getAssetPath } from 'utils/asset-utils';
import { getBlogUrl, getFrontEndUrl } from 'utils/environment-util';

const SHEF_LOGO_PATH = getAssetPath('/images/CDN/shef-logo.svg');

interface IProps {
  className?: string;
}

export const HeaderBar: React.FC<IProps> = ({ className }) => {
  const frontEndUrl = getFrontEndUrl();
  const blogUrl = getBlogUrl();
  return (
    <div
      className={`${className} flex flex-row justify-between border-b border-neutral-800 p-2 text-base font-semibold text-neutral-700 md:px-12`}>
      <div className='flex flex-row gap-9'>
        <NoFollowLink href={frontEndUrl}>
          <img src={SHEF_LOGO_PATH} alt='Shef Logo' className={`h-6 w-[60px]`} />
        </NoFollowLink>
        <div className='hidden flex-row items-center gap-5 md:flex'>
          <NoFollowLink
            href={`${blogUrl}/our-story`}
            className='text-center text-xs font-black leading-[18px] text-[#5C5C5C]'>
            Our Story
          </NoFollowLink>
          <NoFollowLink
            href={`${frontEndUrl}/become-a-shef`}
            className='text-center text-xs font-black leading-[18px] text-[#5C5C5C]'>
            Become a shef
          </NoFollowLink>
        </div>
      </div>
      <div className='flex flex-row items-center gap-4'>
        <NoFollowLink
          href={`${frontEndUrl}/login`}
          className='text-center text-xs font-black leading-[18px] text-[#5C5C5C]'>
          Log In
        </NoFollowLink>
        <NoFollowLink
          href={`${frontEndUrl}/register`}
          className='rounded-xl bg-[#E61953] px-4 py-2 text-center text-xs font-medium leading-none text-white'>
          Sign Up
        </NoFollowLink>
      </div>
    </div>
  );
};
